import { SVGProps } from "react";

const TypeCrossIcon = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" fill="#D6D6D6" />
      <path
        d="M16 8L12 12M12 12L8 16M12 12L16 16M12 12L8 8"
        stroke="#7A7A7A"
        strokeWidth="1.2"
      />
    </svg>
  );
};

export default TypeCrossIcon;
